import { createRoot } from "react-dom/client";
// Redux
// https://github.com/rt2zz/redux-persist
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import store, { persistor } from "./setup/redux/Store";

// Apps
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 **/
import "cpl-react-common/Helpers/DateExtensions";
import "cpl-react-common/Helpers/NumberExtensions";
import { AppRoutes } from "./app/routing/AppRoutes";
import { AppErrorBoundary } from "./app/pages/errors/AppErrorBoundary";
import { reloadOnChunkLoadError } from "cpl-react-common/Helpers/reloadOnChunkLoadError";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "./_metronic/assets/sass/style.scss";
import "./_metronic/assets/sass/style.react.scss";
import "./app/assets/sass/cplstyle.scss";

window.addEventListener("vite:preloadError", (event) => {
  reloadOnChunkLoadError(event);
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <AppErrorBoundary>
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={3}
        />
        <AppRoutes />
      </PersistGate>
    </Provider>
  </AppErrorBoundary>
);
